import _ from 'underscore';
import config from '@bingads-webui-component-legacy/config/index';
import { CampaignType } from '@bingads-webui-campaign-react/shell-ui-common';
import imagePmax from '../../media/pmax.svg';
import imageApp from '../../media/app.svg';

const dynamicPermissions = _.result(config.get('permissions'), 'dynamic', {});
const { IsRenameHotelToLodgingEnabled } = dynamicPermissions;

export const allCampaignType = 'allCampaignTypes';

export const DefaultCampaignTypes = [
  {
    id: allCampaignType,
    displayName: _TL_('All campaigns'),
    glyphIconName: 'ba-OEM',
    campaignType: CampaignType.All,
  },
];

export const CandidateCampaignTypes = [
  {
    id: 'Default',
    displayName: _TL_('Search campaigns'),
    glyphIconName: 'ba-SearchCampaigns',
    campaignType: CampaignType.Default,
  }, {
    id: 'Shopping',
    displayName: _TL_('Shopping campaigns'),
    glyphIconName: 'ba-Shop',
    campaignType: CampaignType.Shopping,
  }, {
    id: 'Audience',
    displayName: _TL_('Audience campaigns'),
    glyphIconName: 'ba-AudienceCampaigns',
    campaignType: CampaignType.Audience,
  }, {
    id: 'Smart',
    displayName: _TL_('Smart campaigns'),
    glyphIconName: 'ba-CampaignsSettings',
    campaignType: CampaignType.Smart,
  },
  {
    id: 'Hotel',
    displayName: IsRenameHotelToLodgingEnabled ? _TL_('Lodging campaigns') : _TL_('Hotel campaigns'),
    glyphIconName: 'ba-Hotel',
    campaignType: CampaignType.Hotel,
  },
  {
    id: 'Pmax',
    displayName: _TL_('Performance Max campaigns'),
    imageSrc: imagePmax,
    campaignType: CampaignType.PerformanceMax,
  },
  {
    id: 'App',
    displayName: _TL_('App campaigns'),
    imageSrc: imageApp,
    campaignType: CampaignType.App,
  },
];

export function getCampaignTypesProps(types, selectedCampaignType, i18n) {
  const visibleCampaignTypes = _.filter(
    CandidateCampaignTypes,
    campaignType => _.contains(types, campaignType.campaignType)
  );

  return _.chain(DefaultCampaignTypes)
    .union(visibleCampaignTypes)
    .map(campaignType => ({
      ...campaignType,
      isSelected: selectedCampaignType === campaignType.campaignType,
      displayName: i18n.getString(campaignType.displayName),
    }))
    .value();
}
